import loanFormModel from '../../../components/loan_application/form_models/loanFormModel';
import { MINIMUM_LOAN_BALANCE } from '../../../constants';
import { ValidationSchema } from '../../../validations/interfaces';
import { Validation } from '../../../validations/Validation';
import * as Yup from 'yup';

const {
  formField: { loanBalance, onSystemProperty },
} = loanFormModel;

export class MortgageLoanBalanceValidation implements ValidationSchema {
  public name = loanBalance.name;
  public label = loanBalance.label;
  public dependsOn: string[] = [onSystemProperty.name];
  public type = 'number';
  public required = {
    message: loanBalance.requiredErrorMsg,
    value: true,
  };
  public nullable = true;
  public min = {
    message: `Remaining principal must be greater than $${MINIMUM_LOAN_BALANCE}`,
    value: MINIMUM_LOAN_BALANCE,
  };

  public typeError = {
    message: 'Please enter a number.',
    value: true,
  };

  public when(
    onSystemProperty: string,
    schema: Yup.NumberSchema,
    context: any
  ) {
    if (onSystemProperty === 'Yes') {
      return schema.required(loanBalance.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new MortgageLoanBalanceValidation());
